// src/pages/SubscriptionPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; // 确保引入 Link
import { Container, Box, Typography, Card, CardContent, CardActions, Button, Grid, Divider, CssBaseline } from '@mui/material'; // Import Material UI components

const SubscriptionPage = () => {
    const [subscriptionPlans, setSubscriptionPlans] = useState([]); // State to hold subscription plans
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchSubscriptionPlans = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get('/subscriptions/plans'); // Assuming backend API endpoint is /subscriptions/plans
                setSubscriptionPlans(response.data); // Set the fetched plans to state
                setLoading(false);
            } catch (error) {
                console.error('Failed to fetch subscription plans:', error.response?.data?.message || 'Failed to fetch subscription plans');
                setError(error.response?.data?.message || 'Failed to fetch subscription plans');
                setLoading(false);
            }
        };

        fetchSubscriptionPlans();
    }, []);

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Typography variant="h6">加载订阅套餐中...</Typography>
        </Box>;
    }

    if (error) {
        return <Container maxWidth="md" sx={{ mt: 4 }}>
            <Typography color="error" variant="body1">获取订阅套餐失败: {error}</Typography>
        </Container>;
    }

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 4 }}>
            <CssBaseline />
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}> {/* Centered content container */}
                <Typography component="h1" variant="h4" align="center" gutterBottom> {/* Main title */}
                    选择您的订阅套餐
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" align="center"> {/* Subtitle */}
                    解锁更多功能，畅享产品大师智库
                </Typography>
            </Box>

            <Grid container spacing={4} justifyContent="center"> {/* Grid container for plan cards, centered */}
                {subscriptionPlans.map((plan) => (
                    <Grid item key={plan.id} xs={12} sm={6} md={4}> {/* Grid item for each plan card */}
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}> {/* Card container with Flexbox layout */}
                            <CardContent sx={{ padding: 3 }}> {/* Card content padding */}
                                <Typography gutterBottom variant="h5" component="div" align="center"> {/* Plan name */}
                                    {plan.name}
                                </Typography>
                                <Typography variant="subtitle1" align="center" color="text.secondary"  gutterBottom> {/* Plan price */}
                                    {plan.price}
                                </Typography>
                                <Divider sx={{ my: 2 }} /> {/* Divider */}
                                <Typography variant="body2" color="text.secondary"> {/* Plan features */}
                                    {plan.features}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{ padding: 3, display: 'flex', justifyContent: 'center' }}> {/* Card actions (button) */}
                                <Button size="large" color="primary" variant="contained" component={Link} to="/payment" state={{ planId: plan.id, planName: plan.name, planPrice: plan.price }}> {/* Subscribe button */}
                                    订阅
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Box sx={{ mt: 4, textAlign: 'center' }}> {/* Bottom links container */}
                <Typography variant="body2">
                    <Link to="/profile" variant="body2" sx={{ mr: 2 }}>返回个人资料</Link>
                    <Link to="/" variant="body2">返回首页</Link>
                </Typography>
            </Box>
        </Container>
    );
};

export default SubscriptionPage;